// Human-readable recurrence summary for a routine's schedule fields.
// Used on list rows, badges, and the designer live preview.

const DAY_LABELS = {
    monday: "Mon", tuesday: "Tue", wednesday: "Wed", thursday: "Thu",
    friday: "Fri", saturday: "Sat", sunday: "Sun",
};

function formatTime(timeOfDay) {
    if (!timeOfDay || !/^\d{1,2}:\d{2}$/.test(timeOfDay)) return timeOfDay || "";
    const parts = timeOfDay.split(":");
    let h = parseInt(parts[0], 10);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12;
    if (h === 0) h = 12;
    return `${h}:${parts[1]} ${ampm}`;
}

function ordinal(n) {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function formatSchedule(routine) {
    if (!routine) return "";
    const every = routine.every > 0 ? routine.every : 1;
    const at = routine.timeOfDay ? ` at ${formatTime(routine.timeOfDay)}` : "";
    const tz = routine.timeZone ? ` · ${routine.timeZone}` : "";

    switch ((routine.recurringType || "day").toLowerCase()) {
        case "minute":
            return (every === 1 ? "Every minute" : `Every ${every} minutes`) + tz;
        case "hour":
            return (every === 1 ? "Every hour" : `Every ${every} hours`) + tz;
        case "week": {
            const days = (routine.recurringWeeks || [])
                .map(d => DAY_LABELS[String(d).toLowerCase()] || d);
            const base = days.length
                ? `Weekly on ${days.join(", ")}`
                : (every === 1 ? "Every week" : `Every ${every} weeks`);
            return base + at + tz;
        }
        case "month": {
            let base;
            if (routine.recurringMonthEnd) base = "Monthly on the last day";
            else if (routine.recurringMonthStart) base = "Monthly on the 1st";
            else if (routine.recurringMonthDay && routine.recurringMonthDayEvery)
                base = `Monthly on the ${ordinal(routine.recurringMonthDayEvery)}`;
            else base = every === 1 ? "Every month" : `Every ${every} months`;
            return base + at + tz;
        }
        case "day":
        default:
            return (every === 1 ? "Every day" : `Every ${every} days`) + at + tz;
    }
}

export default formatSchedule;
